import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useSiteContent } from "../contexts/SiteContentContext";

export default function FaqSection() {
  const { text } = useSiteContent();
  const faqList = text.faq_list && text.faq_list.length > 0 ? text.faq_list : [];
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-24 md:py-32 tone-faq overflow-hidden" data-testid="faq-section">
      <div className="lit-faq-light absolute inset-0 pointer-events-none" />
      <div className="relative max-w-[1180px] mx-auto px-[22px] md:px-8 lg:flex lg:flex-col lg:items-center">
        <motion.div
          initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: false, margin: "-100px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="lg:text-center lg:max-w-[700px] lg:mx-auto"
        >
          <span className="eyebrow text-akcent" data-testid="faq-eyebrow">Časté dotazy</span>
          <h2 className="t-h1 mt-4 text-krem-100">Vše, co potřebujete<br className="hidden lg:block" /> vědět.</h2>
          <p className="t-body mt-4 text-tlum-dark mb-6">Máte další dotazy? Napište nebo zavolejte, rádi pomůžeme.</p>
          <a href="#kontakt" className="btn-accent inline-flex lg:mx-auto" data-testid="faq-contact-btn">Kontaktujte nás</a>
        </motion.div>

        <div className="lg:max-w-[700px] lg:w-full lg:mx-auto lg:mt-10">
          {faqList.map((item, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: false }}
                transition={{ duration: 0.4, delay: i * 0.05, ease: "easeOut" }}
                style={{ borderBottom: "0.5px solid var(--linka-tmava)" }}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full text-left py-5 flex justify-between items-center gap-4 text-krem-100"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="t-h3 faq-question-text">{item.q}</span>
                  <span className="faq-plus faq-plus-dark" data-open={isOpen} />
                </button>
                <AnimatePresence>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                      className="overflow-hidden"
                    >
                      <p className="pb-5 text-tlum-dark" style={{ fontSize: "15.7px", lineHeight: 1.5 }} data-testid={`faq-answer-${i}`}>{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
